export default "__VITE_ASSET__Dh_Pvf29__"